import React, { useEffect, useMemo, useState } from 'react'
import Switch from 'react-switch';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import { getAllData, patchUsersData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from 'react-redux';
import { loaderActions } from '../../../_actions/loader.actions';
import { useNavigate } from 'react-router-dom';
import CustomTable from '../../../customControl/CustomTable';
import CommonFilter from '../../../customControl/CommonFilter';
import { getHTMLContentCharacterLength } from '../../commonClass/CommonValidation';
import JoditEditor from 'jodit-react';

const FAQ = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formFaq, setFormFaq] = useState({
        FAQId: 0,
        FAQTABId: 0,
        Question: '',
        IsActive: false,
    })

    const [answer, setAnswer] = useState("");

    const [FAQTab, setFAQTab] = useState([])

    const [faqListData, setFaqListData] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [formError, setFormError] = useState(null);

    const [modalShow, setModalShow] = useState(false)
    const [activeId, setActiveId] = useState(false);

    const [editorRef, setEditorRef] = useState(null);
    const [richboxheight, setRichBoxHeight] = useState(false)

    const [disabled, setDisabled] = useState(false);
    const [editdisabled, setEditDisabled] = useState(false);
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");

    const [searchDisabled, setSerachDisable] = useState(false);
    const [searchvalue, setSearchValue] = useState();
    const [searchby, setSerachBy] = useState('All');

    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    //#region handle rights
    useEffect(() => {
        if (user?.length > 0) {
            const pathName = window?.location?.pathname?.toLowerCase();
            const hasRights = user?.find(x => x?.PageLink?.toLowerCase() === pathName)
            if (!hasRights?.URightView) {
                navigate("/dashboard");
                return;
            }
            setUserAdd(hasRights?.URightAdd);
            setUserEdit(hasRights?.URightEdit);
            setUserExport(hasRights?.URightExport);
        }
    }, [user])
    //#endregion

    //#region colums of Data tables
    const columns = [
        {
            name: 'Question',
            key: "question",
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (faq) => faq?.question,
        },
        {
            name: 'Active',
            key: "IsActiveFormat",
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (faq) => faq?.IsActiveFormat
        },
        {
            name: 'Created Date',
            key: "CreatedDateFormat",
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (faq) => new Date(faq?.createdDate),
            format: (faq) => faq?.CreatedDateFormat,
        },
        {
            name: 'Edit',
            isSearch: false,
            isExport: false,
            selector: (faq) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditViewMode("Edit", faq?.faqId)}></i></button>
        },
        {
            name: 'View',
            isSearch: false,
            isExport: false,
            selector: (faq) => <i className="fa fa-eye" onClick={() => handleEditViewMode("View", faq?.faqId)}></i>
        }
    ];
    //#endregion


    //#region retrieve data on Edit & View Button
    const handleEditViewMode = (type, id) => {
        setDisabled(type === "Edit" ? false : true);
        setEditDisabled(false);
        setSerachDisable(true);
        setButtonAddEditText(type === "Edit" ? "Update" : "Add");
        RetriveData(id);
    }

    function RetriveData(id) {
        const retrieveItem = faqListData?.find((item) => item?.faqId === id) || null;
        if (retrieveItem) {
            setFormFaq((prev) => ({
                ...prev,
                Question: retrieveItem?.question,
                FAQId: retrieveItem?.faqId,
                IsActive: retrieveItem?.isActive,
            }))
            setAnswer(retrieveItem?.answer);
            setActiveId(retrieveItem?.isActive);
        }
    }
    //#endregion

    //#region Question text box
    const handleOnChange = (name, value) => {
        setFormFaq((prev) => ({ ...prev, [name]: value }))
        setEditDisabled(false);
        setFormError(null)
    }
    //#endregion

    //#region Answer Rich Text Box
    const answerconfig = useMemo(
        () => ({
            readonly: false, // all options from https://xdsoft.net/jodit/doc/,
            height: '100%',
            maxHeight: richboxheight === true ? 200 : 500,
            width: '100%',
            statusbar: false,
            disablePlugins: ["source"],
            removeButtons: ["about", "image", "link", "select", "video"],
            toolbarAdaptive: false,
            //autofocus: true,
            defaultMode: "1",
            disabled: disabled ? true : false
        }),
        [disabled, richboxheight]
    );

    //#endregion

    //#region Active/Inactive button
    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            setFormFaq((prev) => ({ ...prev, IsActive: e }));
            setActiveId(!activeId);
            setFormError(null);
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setFormFaq((prev) => ({ ...prev, IsActive: !activeId }));
            setActiveId(!activeId)
            setEditDisabled(false);
            setFormError(null);
        }
        setModalShow(false);
    }
    //#endregion

    //#region validations
    const validateData = () => {
        let status = true;
        let error = {};
        if (!formFaq?.Question || formFaq?.Question?.trim()?.length === 0) {
            error.Question = 'Please enter Question'
        }
        if (!answer || getHTMLContentCharacterLength(answer) === 0) {
            error.Answer = 'Please enter Answer'
        }
        // if (typeof formFaq.Answer === 'string' && formFaq.Answer?.trim()?.length > 2000) {
        //     errors.answer = 'Maximum character length is 2000'
        //     error.push('Answer')
        // }
        setFormError(error)

        if (Object.keys(error)?.length > 0) {
            status = false;
            const id = Object.keys(error)?.[0];
            document.getElementById(id)?.focus();
        }

        return status;
    }
    //#endregion

    //#region Add/Update button
    const handleAddClick = async () => {
        if (validateData()) {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const payload = {
                    ...formFaq,
                    Answer: answer
                }
                const insertupdatefaq = buttonaddeditText === "Add" ?
                    await postUsersData('/master/v1/insertfaq', payload) : await patchUsersData("/master/v1/updatefaq", payload);

                if (insertupdatefaq?.status) {
                    dispatch({ type: 'ALERTING', message: insertupdatefaq?.message });
                    handleClear();
                    getallfaq(formFaq?.FAQTABId);
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch({ type: 'ALERTING', message: insertupdatefaq?.message });
                    dispatch(loaderActions.end());
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end());
            }
        }
    }
    //#endregion

    //#region clear button
    const handleClear = () => {

        setFormError(null)
        setFormFaq((prev) => ({ ...prev, FAQId: 0, Question: '', IsActive: false }))
        setAnswer("");
        setActiveId(false);
        setButtonAddEditText('Add');
        setDisabled(false);
        setEditDisabled(false);

        setSerachDisable(false);
        setSerachBy('All');
        setSearchValue('');

        if (document.querySelector('.jodit-wysiwyg') !== null) {
            document.querySelector('.jodit-wysiwyg').innerHTML = '';
        }
        // if (editorRef?.current) {
        //     editorRef.current.value = ''; // clear the content
        // }
    }
    //#endregion

    //#region search FAQs by credentials

    //#endregion

    //#region Date format
    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }
    //#endregion


    //#region change FAQ Tab
    const handleFAQTab = (id) => {
        if (formFaq?.FAQTABId !== id) {
            handleClear();
            setFormFaq((prev) => ({ ...prev, FAQTABId: id }));

            dispatch(loaderActions.start());
            Promise.allSettled([
                getallfaq(id)
            ])
        }
    }
    //#endregion

    const getallfaq = async (id) => {
        dispatch(loaderActions.start());
        const FAQTABId = id
        const allfaq = await postUsersData("/master/v1/getallfaq", { FAQTABId });
        if (allfaq?.status) {
            allfaq?.data?.map((obj) => {
                obj.IsActiveFormat = obj?.isActive ? 'Active' : 'InActive'
                obj.CreatedDateFormat = formatDate(obj?.createdDate)
                return obj;
            });

            setFaqListData(allfaq?.data ? allfaq?.data : []);
            setFilterList(allfaq?.data ? allfaq?.data : []);
        }
        else {
            setFaqListData([]);
            setFilterList([]);
        }
        dispatch(loaderActions.end());
    }

    const getfaqtab = async () => {
        const faqtab = await getAllData('/master/v1/getfaqtab');
        if (faqtab?.status) {
            setFAQTab(faqtab?.data ? faqtab?.data : []);

            const defaultFaqTabId = faqtab?.data?.find((item) => item?.IsDefault)?.FAQTABId || faqtab?.data?.[0]?.FAQTABId || 1;

            setFormFaq((prev) => ({ ...prev, FAQTABId: defaultFaqTabId }))
            defaultFaqTabId && getallfaq(defaultFaqTabId);
        }
        else {
            setFAQTab([]);
        }
    }

    //#region useEffects
    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                dispatch(loaderActions.start());
                Promise.allSettled([
                    getfaqtab()
                ]).then().catch((error) => console.error(error))
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end());
            }
        }
        fetchData();
    }, [])



    useEffect(() => {
        const richtexteboxheight = document.getElementById("layoutSidenav_content").clientWidth
        if (richtexteboxheight > 1253) {
            setRichBoxHeight(true)
        }
        else {
            setRichBoxHeight(false)
        }
    }, []);
    //#endregion

    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>FAQ</h3>
            </div>
            <div className="container-fluid form_border pt-5 my-3">
                <div className="mb-3 row mx-1">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-lg-1">
                        <div className="faq_tab d-flex justify-content-center align-items-center flex-wrap">
                            <div className='container tab_section px-0'>
                                <ul className="nav nav-pills nav-justified mb-3 pt-3" id="pills-tab" role="tablist">
                                    {FAQTab?.map((tab, index) => {
                                        return (
                                            <li key={tab?.FAQTABId} className="nav-item mx-lg-5 mx-md-1 mx-5 mt-1" role="presentation">
                                                <button
                                                    className={`nav-link ${tab?.FAQTABId === formFaq?.FAQTABId ? "active" : ""}`}
                                                    id={`faqTab${tab?.FAQTABId}${index + 1}`}
                                                    data-bs-toggle="pill"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls={`faqTab${tab?.FAQTABId}${index + 1}`}
                                                    aria-selected={tab?.FAQTABId === formFaq?.FAQTABId ? "true" : "false"}
                                                    onClick={(e) => handleFAQTab(tab?.FAQTABId)}
                                                >
                                                    {tab?.FAQTABName}
                                                </button>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <form action="" >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row">
                                <div className='col-md-12'>
                                    <div className='row'>
                                        {formError?.duplicate && <div className="text-center text-danger pb-3"> {formError?.duplicate} </div>}
                                        <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                            <label htmlFor="Question" className="col-form-label required">Question</label>
                                        </div>
                                        <div className="col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                            <input
                                                type='text'
                                                className='form-control'
                                                name="Question"
                                                id="Question"
                                                maxLength={250}
                                                value={formFaq.Question || ""}
                                                onChange={(e) => handleOnChange(e?.target?.name, e?.target?.value)}
                                                placeholder='Enter question'
                                                disabled={disabled ? true : false}
                                            />
                                            {formError?.Question && <div className="text-start text-danger fs_14"> {formError?.Question} </div>}
                                        </div>

                                        <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                            <label htmlFor="Answer" className="col-form-label required">Answer</label>
                                        </div>
                                        <div className=" col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                            {/* <RichTextBox
                                                field="Answer"
                                                fieldvalue={answer}
                                                tabIndex={1}
                                                OnChangeofRichBox={(value) => { setAnswer(value) }}
                                                handleOnBlur={(value) => { setAnswer(value) }}
                                                textconfig={answerconfig}
                                                setRef={setEditorRef}
                                            /> */}
                                            <JoditEditor
                                                className='col-12'
                                                name="Answer"
                                                id="Answer"
                                                value={answer}
                                                tabIndex={1}
                                                onChange={() => { }}
                                                onBlur={(value) => setAnswer(value)}
                                                config={
                                                    {
                                                        ...answerconfig,
                                                        controls: {
                                                            ...answerconfig?.controls,
                                                            font: {
                                                                ...answerconfig?.controls?.font,
                                                                list: {
                                                                    ...answerconfig?.controls?.font?.list,
                                                                    'sans-serif': 'San Serif',
                                                                    'Open Sans': ' Open Sans'
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            />
                                            {formError?.Answer && <div className="text-start text-danger fs_14"> {formError?.Answer} </div>}
                                        </div>

                                        <div className="col-lg-3 col-md-12 col-sm-12">
                                            <label htmlFor="active" className="col-form-label">Active</label>
                                        </div>
                                        <div className="col-auto col-lg-6 " disabled={false}>
                                            <Switch
                                                id='active'
                                                onChange={handleisActive}
                                                checked={activeId}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </div>
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        <button type="button" className="btn btn-primary mx-1" disabled={disabled || editdisabled || (buttonaddeditText === "Add" ? !useradd : !useredit)} onClick={() => handleAddClick()}> {buttonaddeditText} </button>
                        <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClear} >Clear</button>
                    </div>


                    <CommonFilter
                        columns={columns}
                        filterList={filterList}
                        searchDisabled={searchDisabled}
                        getdata={() => getallfaq(formFaq?.FAQTABId)}
                        setlistdata={setFaqListData}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={faqListData}
                        PdfExport={false}
                        ExportToExcel={false}
                        disabled={!userexport}
                    />

                </form>
            </div>
        </>
    )
}

export default FAQ